import { flowRight as compose } from 'lodash';

import dataView from '~lib/common/hoc/dataView';
import renameProps from '~lib/common/hoc/renameProps';
import withUser from '~lib/common/hoc/withUser';

import PatientStance from './PatientStance.vue';
import queries from '~lib/common/queries/State';

const enhance = compose(
  dataView({ queries, append: true }),
  renameProps({ data: 'states' }),
);

export default withUser()(enhance(PatientStance));
